// One-time migration: every local save that predates the unified
// instance/save system is tagged with a server-side solo instance
// id so it shows up in the SessionBrowser save list. Runs at most
// once per device (gated by a localStorage flag).

import { listGameSessions, saveGameSession, loadGameSession } from './sessionStorage';
import { createInstance as apiCreateInstance } from '../arena/instancesApi';

const MIGRATED_KEY = 'valkenhall.instanceMigrationV1';

export async function migrateSoloSavesToInstances() {
  try {
    if (typeof localStorage !== 'undefined' && localStorage.getItem(MIGRATED_KEY)) {
      return;
    }
    const summaries = await listGameSessions();
    for (const summary of summaries) {
      if (summary.instanceId) continue; // already migrated
      try {
        const full = await loadGameSession(summary.id);
        if (full?.instanceId) continue; // someone else migrated it
        const mode = (full?.mode === 'sandbox' || summary.mode === 'sandbox')
          ? 'sandbox'
          : 'match';
        const inst = await apiCreateInstance({
          visibility: 'solo',
          mode,
          rankedOptIn: false,
          seatsMin: 1,
          seatsMax: 1,
        });
        await saveGameSession({
          ...full,
          id: summary.id,
          name: full.name || summary.name,
          instanceId: inst.id,
          visibility: 'solo',
          mode,
        });
      } catch (err) {
        console.warn('[migrate] skip', summary.id, err.message);
      }
    }
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(MIGRATED_KEY, new Date().toISOString());
    }
  } catch (err) {
    console.warn('[migrate] solo-saves pass skipped:', err.message);
  }
}
